export default {
  welcome: 'Welcome to gotin',
  welcomeNjcb: '欢迎进入“你好世界”，\n开启元宇宙探索之旅！',
  firstName: 'First name',
  lastName: 'Last name',
  createAccount: 'Create new account ',
  email: 'Email (We recommend you use your business email address)',
  enterPassword: 'Enter password',
  rePassword: 'Re-enter password',
  tips: 'By clicking "Register" or "Continue with LinkedIn", I accept the Terms Of Service.',
  registerUser: 'Sign Up',
  success: 'Register successfully',
  exists: 'Already Registered, please login',
  notExists: 'Account is not registered',
  bindedPhone: 'The phone number has been registered, please log in',
  bindedEmail: 'The email has been registered, please log in',
  login: 'Sign in',
  register: 'Sign up',
  next: 'Next',
  //
  backLogin: 'back',
  createAccount1: 'Create Account',
  email1: 'Email',
  recommendEmail: 'Recommend to use company emails',
  setPass: 'Password',
  setANewPassword: 'Set a new password',
  showPasswordRules:
    'Password must be at least 8 characters long and contain at least a letter',
  confirmPass: 'Re-enter password',
  or: 'OR',
  linkedinLogin: 'LinkedIn Login',
  inputEmail: 'Please enter your email',
  inputPhone: 'Please enter your phone number',
  enterYourEmail: 'Enter your email',
  enterYourPhone: 'Phone number',
  needCanUseEmail: 'Please provide a valid email address',
  needCanUsePhone: 'Please provide a valid phone number',
  setPassPop: 'Please input password',
  eightMinPassword: 'Password must be at least 8 character long',
  passwordRules: 'Please follow password rules',
  confirmPassPop: 'Please confirm your password',
  reInputPassword: 'Please confirm your password ',
  noMatchPassword: 'Passwords do not match',
  acceptTermsPop: 'Please accept terms and conditions',
  emailConsent: 'EMAIL CONSENT',
  emailConsentText:
    'To ensure you stay up-to-date on the latest developments in the mobile industry, we would like to send you information about events, products, services and initiatives, as well as industry news. Please subscribe by ticking this box; once subscribed, you can tailor what you receive from us at any time, or unsubscribe, should you wish.',
  subscribe: 'Subscribe newsletters and notifications from gotin.',
  readPreText: "By continuing, I agree to gotin's ",
  readPreTextPorsche718: 'I agree to the ',
  readPreTextZlzp: 'I agree to the ',
  and: ',',
  andPorsche718: ' and ',
  andPreTextZlzp: ' and ',
  termsName: 'Terms of Service',
  privacyPolicyName: 'Privacy policy',
  labelRegisteredPhone: 'Please enter your phone number',
  labelCode: 'Please enter Security',
  verificationCode: 'Verification code',
  offLine: 'Unstable network, please try again later',
  owndesc: 'Unregistered accounts will be automatically registered',
  porscheOwndesc718: 'Unregistered accounts will be automatically registered',
  gsmaAgreeReadPreText:
    'I consent to the GSMA group (specifically GSMA Ltd LLC, GSMA 4YFN Event Management, SL, GSM Association, GSMA Advisory Services Ltd, GSMA Services LLC and GSMA (Shanghai) Co. Ltd) sending me information by email about GSMA products & services. This includes information about GSMA’s events, its device/network services and mobile industry news & insights. Please subscribe by ticking this box; once subscribed, you can tailor what you receive from us at any time, or unsubscribe, should you wish. For more information on how we collect and process personal data at MWC Barcelona, please read our ',
  gsmaAgreeReadPreText2:
    '. as a condition of registering for MWC Live.(Note: Registration cannot be completed without agreement.)',
  gsmaAgreeReadPreText3: 'Privacy Notice for MWC Barcelona and 4YFN Attendees.',
}
